module.exports = __webpack_public_path__ + "static/media/noData.6ada6a32.png";